import { Box, Button } from "@mui/material";
export interface SavePanelProps {
    disabled?: boolean;
    disabledSave?: boolean;
    saveText?: string;
    cancelText?: string;
    onSave?: () => void;
    onCancel?: () => void;
}

const SavePanel = (props: SavePanelProps) => {
    const {
        saveText = "Save",
        cancelText = "Cancel",
        onSave,
        onCancel,
        disabled = false,
        disabledSave = false
    } = props;

    return (
        <Box display="flex" width={"100%"} justifyContent="flex-end">
            <Box mr={1}>
                <Button
                    sx={{ width: 120 }}
                    variant="outlined"
                    tabIndex={-1}
                    onClick={onCancel}
                    disabled={disabled}
                >
                    {cancelText}
                </Button>
            </Box>
            <Box>
                <Button
                    sx={{ width: 120 }}
                    // startIcon={<SaveIcon />}
                    color="primary"
                    onClick={onSave}
                    type="submit"
                    disabled={disabled || disabledSave}
                >
                    {saveText}
                </Button>
            </Box>
        </Box>
    );
};

export default SavePanel;
